/* eslint-disable react-hooks/exhaustive-deps */
import { useSelector } from 'react-redux'
import { FormControl, MenuItem, Select, Box } from '@mui/material'

const ViewSelector = ({ onChange, value, disabled }) => {
  const roles = useSelector((state) => state?.session.user.roles?.map((r) => r.id))

  let optionsCharts = [
    {
      value: 'filter-by-student',
      label: 'Filter by student'
    },
    {
      value: 'filter-by-classes',
      label: 'Filter by classes'
    }
  ]

  return (
    <>
      {roles.some((role) => !['Parent', 'Student'].includes(role)) && (
        <Box className='py-1 px-4 max-w-150px min-w-150px absolute top-0px bottom-0px left-0px flex flex-col justify-center overflow-auto bg-primary'>
          <FormControl
            disabled={disabled}
            variant='outlined'
            className='max-w-150px min-w-150px bg-background rounded'
          >
            <Select variant='outlined' onChange={(e) => onChange(e.target.value)} size='small' value={value}>
              {optionsCharts?.map((el) => (
                <MenuItem key={`view-selector-analytics-curriculum-${el.value}`} value={el.value}>
                  {el.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      )}
    </>
  )
}

export default ViewSelector
